<div class="form-container" *ngIf="totalItems === 0 || totalItems > 0" id="top">
  <form [formGroup]="flowListForm">
    <div class="col-12 row heading form-header">
      <div class="col-lg-6 results-heading">
        <div class="results-heading-title">
          <div class="title">{{ 'ORDERS.LIST.TITLE' | translate }}</div>
          <div class="subtitle">{{ 'FLOWS.LIST.SUBTITLE' | translate }}</div>
        </div>
        <div class="results-heading-text">
          <div class="count">
            <span *ngIf="totalItems > 1 || totalItems === 0">{{ 'FLOWS.LIST.COUNT' | translate: { count: totalItems } }}</span>
            <span *ngIf="totalItems === 1">{{ 'FLOWS.LIST.COUNT_1' | translate }}</span>
          </div>
          <div class="count-postscript" *ngIf="authorization.FLOW.MULTI_ACCEPT || canMultiAcceptFlows">
            {{ 'FLOWS.LIST.COUNT-POSTSCRIPT' | translate }},
            <span class="bold">{{ 'FLOWS.LIST.SELECTED' | translate: { selected: selected } }}</span>
          </div>
        </div>
        <div class="excel-btn" *ngIf="totalItems >= 1">
          <eps-button
            [busy]="isDownloading"
            [disabled]="isDownloading"
            (buttonClick)="downloadList.emit('XLS')"
            label="ORDERS.LIST.EXCEL"
          ></eps-button>
        </div>
      </div>

      <div class="col-lg-6 results-actions" *ngIf="totalItems > 0">
        <div class="accept-cancel-buttons" *ngIf="authorization.FLOW.MULTI_ACCEPT || canMultiAcceptFlows">
          <eps-button
            [disabled]="isDownloading"
            (buttonClick)="toggleCollapseAll()"
            [label]="'SHARED.LABELS.' + (showAll ? 'COLLAPSE_ALL' : 'SHOW_ALL')"
          ></eps-button>
          <eps-button
            *ngIf="canAcceptConfirmSelected()"
            [disabled]="isDownloading || isAcceptHandshakeSelectedDisabled()"
            (buttonClick)="acceptFlowsClicked()"
            [ngClass]="{accept: true, disabled: isDownloading || isAcceptHandshakeSelectedDisabled()}"
            buttonIcon="check"
            label="FLOWS.LIST.BUTTONS.ACCEPT_SELECTED"
          ></eps-button>
        </div>
      </div>
    </div>

    <div class="row col-12 pagination" *ngIf="!isLoading && totalItems > 0">
      <app-pager [itemsPerPage]="filter.pageSize" (pageChange)="onPageChange($event)" (itemsPerPageChange)="itemsPerPageChange.emit($event)"></app-pager>
    </div>

    <div class="col-12 row bottom-line bold show-from-sm sorters" *ngIf="!smallScreen && totalItems > 0">
      <app-checkbox
        [ngModel]="pageStats.allSelected"
        [ngModelOptions]="{ standalone: true }"
        (change)="toggleSelectAll($event)"
        *ngIf="authorization.FLOW.MULTI_ACCEPT || canMultiAcceptFlows"
      ></app-checkbox>
      <span class="sorter col-md" sortable-header="flowDate" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'FLOWS.LIST.LABELS.FLOW_DATE' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="etmOrderNumber" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'FLOWS.LIST.LABELS.NUMBER' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="customerRefNumber" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'FLOWS.LIST.LABELS.REFERENCE' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="wholesalerId" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'FLOWS.DELIVERY.LABELS.WHOLESALER' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="fromId" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.FROM' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="toId" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'ORDERS.LIST.LABELS.TO' | translate
        }}</span>
      <span class="sorter col-md" sortable-header="handshakeStatus" [sortField]="filter.sortField" [sortAscending]="filter.sortAscending" [sortFn]="sortBnd">{{
        'FLOWS.LIST.LABELS.STATUS_HANDSHAKE' | translate
        }}</span>
      <span class="menu_col"></span>
    </div>

    <div formArrayName="flows" *ngIf="!isLoading">
      <div
        *ngFor="let flow of flows | paginate: { itemsPerPage: filter.pageSize, currentPage: filter.pageNr, totalItems: totalItems }; let i = index"
        [formGroupName]="i"
        class="row col-12 cell soft-line order"
        [ngClass]="{ cancelled: flow.handshakeStatus === '04' || flow.handshakeStatus === '10', striped: bigScreen }"
        [class.canOpen]="authorization.FLOW.GET"
      >

        <mat-menu #menuFlowLine="matMenu" [overlapTrigger]="false" style="align-items: flex-end !important; justify-content: flex-start !important;">
          <button mat-menu-item type="button" (click)="copyFlow.emit(flow)" *ngIf="canCopyFlow(flow)">
            <span>{{ 'ORDERS.LIST.BUTTONS.COPY' | translate }}</span>
          </button>
          <button
            mat-menu-item
            type="button"
            (click)="editFlow.emit({ flow: flow, isHandshaker: flow.isHandshaker, isRegistrar: flow.isRegistrar })"
            *ngIf="canEditFlow(flow)"
          >
            <span>{{ 'FLOWS.LIST.BUTTONS.EDIT_FLOW_REGISTRAR' | translate }}</span>
          </button>
          <button
            mat-menu-item
            type="button"
            (click)="editDispute.emit({ flow: flow, isHandshaker: flow.isHandshaker, isRegistrar: flow.isRegistrar })"
            *ngIf="canDisputeFlow(flow)"
          >
            <span>{{ 'FLOWS.LIST.BUTTONS.EDIT_DISPUTE' | translate }}</span>
          </button>
          <button mat-menu-item type="button" (click)="editAcceptFlow.emit(flow)" *ngIf="canAcceptHandshake(flow)">
            <span>{{ 'FLOWS.LIST.BUTTONS.EDIT_FLOW_HANDSHAKER' | translate }}</span>
          </button>
          <button mat-menu-item type="button" (click)="downloadDocument.emit(flow)">
            <span>{{ 'SHARED.BUTTONS.DOWNLOAD_DOCUMENT' | translate }}</span>
          </button>
        </mat-menu>

        <ng-container *ngIf="smallScreen; else bigScreen">
          <app-item-card
            [clickable]="true"
            [menu]="menuFlowLine"
            (openItemClicked)="openFlow.emit(flow)"
          >
            <div class="item-card-header" header>
              <div class="checkbox-status">
                <div class="checkbox" *ngIf="showCheckbox(flow)">
                  <app-checkbox
                    formControlName="checked"
                    (click)="$event.stopPropagation()"
                    (ngModelChange)="toggleSelected($event, flow)"
                  ></app-checkbox>
                </div>
                <div class="status">
                  <app-status layout="BULLET" mode="order" [type]="flow.status" [size]="1" [height]="40" position="right"></app-status>
                </div>
              </div>
              <div class="etmOrderNumber">{{flow.etmOrderNumber}}</div>
              <div class="orderDate">{{ flow.flowDate | date: dateFormat }}</div>
            </div>
            <div class="item-card-body" body>
              <div class="fromto">
                <div class="from">
                  {{flow.from.name}}
                  <!-- show small discrete dot if customer is handshaker for flow -->
                  <span style="color: lightcyan">{{ flow.handshaker ? '.' : '' }}</span>
                </div>
                <app-arrow [width]="50"></app-arrow>
                <div class="from">{{flow.to.name}}</div>
              </div>
              <div class="body-content row">
                <eps-date-input class="col-12 col-md-6" [value]="flow.flowDate" label="FLOWS.LIST.LABELS.FLOW_DATE" labelWidth="50%" [showErrors]="false" *ngIf="flow.flowDate"></eps-date-input>
                <eps-text-input class="col-12 col-md-6" [value]="flow.customerRefNumber" label="FLOWS.LIST.LABELS.REFERENCE" labelWidth="50%" [showErrors]="false" *ngIf="flow.customerRefNumber"></eps-text-input>
                <eps-text-input class="col-12 col-md-6" [value]="flow.wholesaler?.name" label="FLOWS.DELIVERY.LABELS.WHOLESALER" labelWidth="50%" [showErrors]="false" *ngIf="flow.wholesaler?.name"></eps-text-input>
                <div class="center">
                  <eps-button
                    (click)="preventRouting($event)"
                    (buttonClick)="toggleCollapsed(flow.etmOrderNumber)"
                    type="default" size="small"
                    *ngIf="flow.flowLineItems.length > 0"
                  >
                    <span *ngIf="!isCollapsed(flow.etmOrderNumber)">{{ 'FLOWS.LIST.LABELS.HIDE_ITEMS' | translate }}</span>
                    <span *ngIf="isCollapsed(flow.etmOrderNumber) && flow.flowLineItems.length > 1">{{ 'FLOWS.LIST.LABELS.SHOW_ITEMS' | translate: { count: flow.flowLineItems.length } }}</span>
                    <span *ngIf="isCollapsed(flow.etmOrderNumber) && flow.flowLineItems.length === 1">{{ 'FLOWS.LIST.LABELS.SHOW_1_ITEM' | translate }}</span>
                  </eps-button>
                </div>
                <div class="line-items row" formArrayName="items" *ngIf="!isCollapsed(flow.etmOrderNumber)">
                  <div *ngFor="let item of flow.flowLineItems | oneOrAllFilter: isCollapsed(flow.etmOrderNumber); let j = index" [formGroupName]="j"
                       class="col-12 col-sm-6 col-md-4 col-lg-3 line-item">
                    <div>
                      <eps-select
                        class=""
                        [value]="item.packingId"
                        [options]="definitions.packing.type"
                        label="FLOWS.LIST.LABELS.TYPE"
                        labelPosition="left"
                        labelWidth="50%"
                        autoSelect
                        readonly
                        [showErrors]="false"
                      ></eps-select>
                      <eps-text-input
                        class=" quantity"
                        formControlName="originalQuantity"
                        label="FLOWS.LIST.LABELS.ORIGINAL"
                        labelWidth="50%"
                        labelPosition="left"
                        [clearable]="false"
                        [ngClass]="{editable: flow.editOriginalQuantity}"
                        [readonly]="!flow.editOriginalQuantity"
                        [showErrors]="false"
                        (click)="preventRouting($event)"
                        (ngModelChange)="originalQuantityChanged($event, flow, item)"
                        *ngIf="flow.editOriginalQuantity || item.originalQuantity"
                      ></eps-text-input>
                      <eps-text-input
                        class=" quantity"
                        formControlName="definitiveQuantity"
                        label="FLOWS.LIST.LABELS.DEFINITIVE"
                        labelWidth="50%"
                        labelPosition="left"
                        [clearable]="false"
                        [ngClass]="{editable: flow.editDefinitiveQuantity}"
                        [readonly]="!flow.editDefinitiveQuantity || !canAcceptHandshake(flow)"
                        [showErrors]="false"
                        (click)="preventRouting($event)"
                        (ngModelChange)="definitiveQuantityChanged($event, flow, item)"
                        *ngIf="flow.editDefinitiveQuantity || item.definitiveQuantity"
                      ></eps-text-input>
                      <eps-text-input
                        class=" quantity"
                        label="FLOWS.LIST.LABELS.DIFFERENCE"
                        labelWidth="50%"
                        labelPosition="left"
                        [showErrors]="false"
                        [value]="item.differenceQuantity"
                        *ngIf="item.differenceQuantity"
                      ></eps-text-input>
                      <eps-select
                        class=""
                        label="FLOWS.LIST.LABELS.CONTENT"
                        labelWidth="50%"
                        labelPosition="left"
                        [showErrors]="false"
                        [options]="this.definitions.global.brick"
                        [value]="item.contentId"
                        readonly
                        *ngIf="item.contentId"
                        autoSelect
                      ></eps-select>
                      <eps-text-input
                        class=""
                        label="FLOWS.LIST.LABELS.REFERENCE"
                        labelWidth="50%"
                        labelPosition="left"
                        [showErrors]="false"
                        [value]="item.lineReferenceId"
                        *ngIf="item.lineReferenceId"
                      ></eps-text-input>
                    </div>
                  </div>
                </div>
                <div class="center">
                  <eps-button
                    [ngClass]="{accept: true, disabled: isAcceptHandshakeDisabled(flow)}"
                    (buttonClick)="acceptFlowClicked(flow)"
                    stopPropagation
                    [disabled]="isAcceptHandshakeDisabled(flow)"
                    type="default"
                    size="small"
                    buttonIcon="check"
                    label="FLOWS.LIST.BUTTONS.ACCEPT"
                    *ngIf="canAcceptHandshake(flow)"
                  ></eps-button>
                  <eps-button
                    class="cancel"
                    (buttonClick)="cancelFlowClicked(flow)"
                    stopPropagation
                    [disabled]="isCancelHandshakeDisabled(flow)"
                    type="default"
                    size="small"
                    buttonIcon="check"
                    label="FLOWS.LIST.BUTTONS.CANCEL"
                    *ngIf="canCancelHandshake(flow)"
                  ></eps-button>
                  <eps-button
                    class="confirm"
                    (buttonClick)="confirmFlowClicked(flow)"
                    stopPropagation
                    [disabled]="isConfirmHandshakeDisabled(flow)"
                    buttonIcon="check"
                    label="FLOWS.LIST.BUTTONS.CONFIRM"
                    height="small"
                    stopPropagation
                    *ngIf="canConfirmRegistration(flow)"
                  ></eps-button>
                  <span class="fail" *ngIf="flow.failed">
                    <eps-icon icon="exclamation"></eps-icon>{{ flow.failMessage.message }}
                  </span>
                </div>
              </div>
            </div>
          </app-item-card>
        </ng-container>

        <ng-template #bigScreen>
          <div class="col-lg-12 col-md-12 col-sm-11 flow_line big-screen">
            <div class="checkbox_wrapper">
              <app-checkbox
                formControlName="checked"
                (change)="toggleSelected($event, flow)"
                *ngIf="
                  canAcceptHandshake(flow) || (canConfirmRegistration(flow) && !isSuperUser) || (canMultiAcceptFlows && canAcceptHandshake(flow)) || canConfirmRegistration(flow)
                "
              ></app-checkbox>
            </div>
            <div class="content" (click)="openFlow.emit(flow)">
              <div class="flow_data">
                <div class="flow_data-data">
                  <div class="col-md col-12 desktop-only">
                    {{ flow.flowDate | date: dateFormat }}
                  </div>

                  <div class="col-md col-12 sales-number cell-row">{{ flow.etmOrderNumber }}</div>

                  <div class="col-md col-12 row cell-row">
                    <div class="row col-xs start-xs">
                      <div class="col-xs mobile-only">
                        <span class="bold">{{ 'FLOWS.LIST.LABELS.REFERENCE' | translate }}:</span> {{ flow.customerRefNumber }}
                      </div>
                      <div class="col-xs desktop-only">
                        {{ flow.customerRefNumber }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md col-12 row cell-row">
                    <div class="row col-xs start-xs">
                      <div class="col-xs mobile-only">
                        <span class="bold">{{ 'FLOWS.DELIVERY.LABELS.WHOLESALER' | translate }}:</span> {{ flow.wholesaler?.name }}
                      </div>
                      <div class="col-xs desktop-only">
                        {{ flow.wholesaler?.name }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md col-12 row cell-row">
                    <div class="row col-xs start-xs">
                      <div class="col-xs mobile-only">
                        <span class="bold">{{ 'ORDERS.LIST.LABELS.FROM' | translate }}:</span> {{ flow.from.name }}
                      </div>
                      <div class="col-xs desktop-only">
                        {{ flow.from.name }}
                      </div>
                    </div>
                  </div>

                  <!-- copy -->
                  <div class="col-md col-12 row cell-row">
                    <div class="row col-xs start-xs">
                      <div class="col-xs mobile-only">
                        <span class="bold">{{ 'ORDERS.LIST.LABELS.TO' | translate }}: </span> {{ flow.to.name }}
                      </div>
                      <div class="col-xs desktop-only">
                        {{ flow.to.name }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md col-12 desktop-only">
                    <app-status layout="BULLET" [type]="flow.status" mode="flow" [size]="1" height="30" *ngIf="!flow.blacklisted"></app-status>
                    <i class="fa fa-spinner fa-pulse fa-fw" *ngIf="flow.blacklisted"></i>
                    <span style="color: lightcyan">{{ flow.handshaker ? '.' : '' }}</span>
                    <!-- show small discrete dot if customer is handshaker for flow -->
                    <span class="handshake_date">{{ flow.handshakeDate | date: dateFormat }}</span>
                  </div>

                  <!-- <div class="col-md col-12 desktop-only"></div> -->
                </div>
                <div class="flow_data-menu" *ngIf="!flow.blacklisted">
                  <div class="more_ellipsis" [matMenuTriggerFor]="menuFlowLine" (click)="openMenu($event)">
                    <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- Children -->
                <div class="col-md-8 items">
                  <div class="row heading">
                    <div class="col-sm-12 col-md-2">{{ 'FLOWS.LIST.LABELS.TYPE' | translate }}</div>
                    <div class="col-sm-12 col-md-2">{{ 'FLOWS.LIST.LABELS.ORIGINAL' | translate }}</div>
                    <div class="col-sm-12 col-md-2">{{ 'FLOWS.LIST.LABELS.DEFINITIVE' | translate }}</div>
                    <div class="col-sm-12 col-md-2">{{ 'FLOWS.LIST.LABELS.DIFFERENCE' | translate }}</div>
                    <div class="col-sm-12 col-md-2">{{ 'FLOWS.LIST.LABELS.CONTENT' | translate }}</div>
                    <div class="col-sm-12 col-md-2">{{ 'FLOWS.LIST.LABELS.REFERENCE' | translate }}</div>
                    <div class="col-sm-12 col-md-2 link">
                      <span *ngIf="flow.flowLineItems.length > 1" (click)="preventRouting($event); toggleCollapsed(flow.etmOrderNumber)">
                        <span *ngIf="!isCollapsed(flow.etmOrderNumber)">{{ 'FLOWS.LIST.LABELS.COLLAPSE_COUNT' | translate: { count: flow.flowLineItems.length } }}</span>
                        <span *ngIf="isCollapsed(flow.etmOrderNumber)">{{ 'FLOWS.LIST.LABELS.SHOW_COUNT' | translate: { count: flow.flowLineItems.length } }}</span>
                      </span>
                    </div>
                  </div>
                  <div formArrayName="items" class="items-content">
                    <div class="row item" *ngFor="let item of flow.flowLineItems | oneOrAllFilter: isCollapsed(flow.etmOrderNumber); let j = index" [formGroupName]="j">
                      <div class="col-sm-12 col-md-2">
                        <eps-select
                          [options]="definitions.packing.type"
                          readonly
                          labelPosition="none"
                          [value]="item.packingId"
                        ></eps-select>
                      </div>
                      <div class="col-sm-12 col-md-2" [ngSwitch]="flow.editOriginalQuantity">
                        <input
                          class="quantity"
                          *ngSwitchCase="true"
                          (click)="preventRouting($event)"
                          formControlName="originalQuantity"
                          (ngModelChange)="originalQuantityChanged($event, flow, item)"
                        />
                        <span class="quantity" *ngSwitchCase="false">{{ item.originalQuantity }}</span>
                      </div>
                      <div class="col-sm-12 col-md-2" [ngSwitch]="flow.editDefinitiveQuantity && canAcceptHandshake(flow)">
                        <input
                          class="quantity"
                          *ngSwitchCase="true"
                          (click)="preventRouting($event)"
                          formControlName="definitiveQuantity"
                          (ngModelChange)="definitiveQuantityChanged($event, flow, item)"
                        />
                        <span class="quantity" *ngSwitchCase="false">{{ item.definitiveQuantity }}</span>
                      </div>
                      <div class="col-sm-12 col-md-2">
                        {{ item.differenceQuantity }}
                      </div>
                      <div class="col-sm-12 col-md-2">
                        {{ getContent(item.contentId) }}
                      </div>
                      <div class="col-sm-12 col-md-2">
                        {{ item.lineReferenceId }}
                      </div>
                      <div class="col-sm-12 col-md-2" *ngIf="flow.flowLineItems.length > 1"></div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 flow_accept_button">
                  <eps-button
                    class="default accept"
                    (buttonClick)="acceptFlowClicked(flow)"
                    *ngIf="canAcceptHandshake(flow)"
                    [disabled]="isAcceptHandshakeDisabled(flow)"
                    [busy]="buttonsAreSpinning(flow)"
                    buttonIcon="check"
                    label="FLOWS.LIST.BUTTONS.ACCEPT"
                    height="small"
                    stopPropagation
                  ></eps-button>
                  <eps-button
                    class="default confirm"
                    (buttonClick)="confirmFlowClicked(flow)"
                    *ngIf="canConfirmRegistration(flow)"
                    [disabled]="isConfirmHandshakeDisabled(flow)"
                    [busy]="buttonsAreSpinning(flow)"
                    buttonIcon="check"
                    label="FLOWS.LIST.BUTTONS.CONFIRM"
                    height="small"
                    stopPropagation
                  ></eps-button>
                  <eps-button
                    class="default cancel"
                    (buttonClick)="cancelFlowClicked(flow)"
                    *ngIf="canCancelHandshake(flow)"
                    [disabled]="isCancelHandshakeDisabled(flow)"
                    [busy]="buttonsAreSpinning(flow)"
                    buttonIcon="times"
                    label="FLOWS.LIST.BUTTONS.CANCEL"
                    height="small"
                    stopPropagation
                  ></eps-button>
                  <span class="fail" *ngIf="flow.failed"> <i class="fa fa-exclamation-triangle"></i> {{ flow.failMessage.message }} </span>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </form>
  <div class="loading_spinner" *ngIf="isLoading">
    <i class="fa fa-spinner fa-pulse fa-fw"></i>
  </div>

  <div class="row col-12 pagination" *ngIf="!isLoading && totalItems > 0">
    <app-pager [itemsPerPage]="filter.pageSize" (pageChange)="onPageChange($event)" (itemsPerPageChange)="itemsPerPageChange.emit($event)"></app-pager>
  </div>
</div>
